export function getRatonPerezImageSources(): {
  webp: string
  png: string
} {
  return {
    webp: '/raton-perez/raton-perez.webp',
    png: '/raton-perez/raton-perez.png',
  }
}
